import { Controller } from 'stimulus';
import $script from 'scriptjs';
import { shouldBypassCaptcha } from 'lib/helpers';

export default class RecaptchaController extends Controller {
  /* eslint-disable no-undef */
  connect() {
    if (!shouldBypassCaptcha()) this.initRecaptcha();
  }

  disconnect() {
    if (this.element.dataset.captchaType !== 'invisible') {
      window.removeEventListener('resize', this.rescaleCaptcha);
    }
  }

  initRecaptcha() {
    window.recaptchaCallback = this.recaptchaCallback;

    if (typeof grecaptcha !== 'undefined') {
      recaptchaCallback();
    } else {
      $script('https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=explicit');
    }

    if (this.element.dataset.captchaType !== 'invisible') {
      window.addEventListener('resize', this.rescaleCaptcha);
      this.rescaleCaptcha();
    }
  }

  recaptchaCallback = () => {
    const captchaOptions = { sitekey: process.env.RECAPTCHA_SITE_KEY };

    if (this.element.dataset.captchaType === 'invisible') {
      captchaOptions.size = 'invisible';
      captchaOptions.badge = 'inline';
    }

    const recaptchaId = grecaptcha.render(this.element, captchaOptions);
    this.element.dataset.recaptchaId = recaptchaId;
  }

  rescaleCaptcha = () => {
    const width = this.element.parentNode.clientWidth;
    const scale = width < 302 ? width / 302 : 1.0;

    this.element.style.transform = `scale(${scale})`;
    this.element.style.transformOrigin = '0 0';
  }
  /* eslint-enable no-undef */
}
